module.exports = __webpack_public_path__ + "img/montserrat.f491a76c.png";